import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-white.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-white.svg'


const _hoisted_1 = {
  key: 0,
  class: "cursor-pointer",
  src: _imports_0,
  alt: "up"
}
const _hoisted_2 = {
  key: 1,
  class: "cursor-pointer",
  src: _imports_1,
  alt: "down"
}
const _hoisted_3 = {
  class: "flex flex-col",
  ref: "listContainer"
}
const _hoisted_4 = { class: "w-5 h-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("button", {
      ref: "button-list",
      disabled: _ctx.isDisabled,
      class: ["flex flex-row items-center text-white px-6 py-3 bg-red-lp-100 text-12px xxl:text-14px font-bold rounded-md focus:ring-2 focus:ring-blue ml-8", { 'bg-gray-lp-500 cursor-not-allowed': _ctx.isDisabled }],
      onMousedown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isMouseDown = true)),
      onMouseup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMouseDown = false)),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTooltip($event))),
      onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFocusButton($event))),
      onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShow = false)),
      tabindex: _ctx.isShow ? -1 : 0
    }, [
      _createTextVNode(_toDisplayString(_ctx.isPrintAble ? "Print" : "Booking") + " ", 1),
      (_ctx.isShow)
        ? (_openBlock(), _createBlock("img", _hoisted_1))
        : (_openBlock(), _createBlock("img", _hoisted_2))
    ], 42, ["disabled", "tabindex"]), [
      [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "opTooltip",
      appendTo: "body",
      class: "w-auto"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
            return (_openBlock(), _createBlock("button", {
              key: index,
              ref: `menuRefs-${index}`,
              class: 
              `${
                index !== _ctx.menus.length - 1 ? 'border-b border-gray-lp-400' : ''
              } cursor-pointer py-1`
            ,
              onKeydown: ($event: any) => (_ctx.onKeyDown($event, index))
            }, [
              _createVNode("div", {
                class: "text-12px xxl:text-14px text-gray-lp-300 p-2 flex flex-row items-center",
                onClick: 
                e => {
                  _ctx.action(index);
                  _ctx.hideToggle(_ctx.$event);
                }
              
              }, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("img", {
                    class: "pr-2 h-4 xxl:h-5",
                    src: require(`@/app/ui/assets/svg/${menu.icon}.svg`),
                    alt: menu.icon
                  }, null, 8, ["src", "alt"])
                ]),
                _createTextVNode(" " + _toDisplayString(menu.title), 1)
              ], 8, ["onClick"])
            ], 42, ["onKeydown"]))
          }), 128))
        ], 512)
      ]),
      _: 1
    }, 512)
  ]))
}